import { render, staticRenderFns } from "./action-dialog-generic.vue?vue&type=template&id=4c3e989c"
import script from "./action-dialog-generic.vue?vue&type=script&lang=js"
export * from "./action-dialog-generic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports